import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    gridContainer: {
        display: "flex",
        justifyContent: "space-between",
        boxShadow: "0px 4px 0px rgba(62, 93, 138, 0.2)",
    },
    gridItemPlc: {
        backgroundColor: theme.palette.primary.light,
        padding: theme.spacing(7),
        display: "flex",
        flexDirection: "column",
    },
    gridItemPlcError: {
        backgroundColor: theme.palette.error.lighter,
        padding: theme.spacing(7),
        display: "flex",
        flexDirection: "column",
    },
    gridBox: {
        display: "flex",
        justifyContent: "space-between",
    },
    machineInfoContainer: {
        display: "flex",
    },
    maderaLogo: {
        height: "56px",
        width: "68px",
        margin: `${theme.spacing(1)} ${theme.spacing(6)} 0 0 `,
    },
    machineNameBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    },
    machineName: {
        color: theme.palette.text.primary,
    },
    date: {
        color: theme.palette.primary.dark,
        textAlign: "left",
    },
    downtimeGrid: {
        alignItems: "center",
        justifyContent: "space-between",
    },
    columnDirection: {
        flexDirection: "column",
    },
    dropdownsGrid: {
        display: "flex",
        gap: theme.spacing(4),
        justifyContent: "center",
        alignItems: "center",
        "&$columnDirection": {
            flexDirection: "column",
        },
    },
    clusterDropdownGrid: {
        display: "flex",
        gap: theme.spacing(4),
        alignItems: "center",
        justifyContent: "space-evenly",
        backgroundColor: theme.palette.primary.light,
    },
    indicatorGrid: {
        display: "flex",
        justifyContent: "flex-end",
    },
    clusterNameContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    clusterICon: {
        fontSize: "30px !important",
    },
    clusterHMIContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    backToClusterButton: {
        backgroundColor: "transparent",
        borderWidth: 0,
        padding: 0,
        fontFamily: "inherit",
        fontSize: "inherit",
        fontStyle: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        cursor: "pointer",
    },
    backToClusterButtonIcon: {
        fontSize: "100px !important",
        color: theme.palette.text.primary,
    },
    backToClusterContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
}));
